import { createSlice } from '@reduxjs/toolkit';

// Initial state for the team member slice
const initialState = {
  teamMemberId: null,  // Holds the team_member_id
};

// Create the slice
const teamMemberSlice = createSlice({
  name: 'teamMember',  // Name of the slice
  initialState,        // Initial state
  reducers: {
    // Reducer to set the team_member_id
    setTeamMemberId: (state, action) => {
      state.teamMemberId = action.payload;
    },
  },
});

// Export the action creator
export const { setTeamMemberId } = teamMemberSlice.actions;

// Export the reducer
export default teamMemberSlice.reducer;